module.exports = __webpack_public_path__ + "static/img/energiewende-370x290.44e823ce.jpg";